import { takeLatest, all, takeEvery } from "redux-saga/effects"

import { bookingTypes } from 'reduxModules/actions/BookingActions'
import {
  subscribeBookingsSaga,
  setBookingSaga,
  deleteBookingSaga,
  setBookingStatusSaga,
  subscribeReturnBookingsSaga,
  getRangeBookingsSaga,
  getCarriersBookingsSaga,
  getUserBookingsSaga,
  setPassengerPlaceSaga,
  subscribeWebsiteBookingsSaga,
  subscribeDepartureBookingsSaga
} from './BookingSagas'

import { globalTypes } from 'reduxModules/actions/GlobalActions'
import {
  getCarriersSaga,
  getBusesSaga,
  getDriversSaga,
  createDriverSaga,
  setDriverSaga,
  deleteDriverSaga,
  setBusSaga,
  deleteBusSaga,
  createBusSaga,
} from './GlobalSaga'

import { cityTypes } from 'reduxModules/actions/CityActions'
import {
  getAllCitiesSaga,
  getRouteCitiesSaga,
  setSystemCitySaga,
  disableCitySaga,
  setCityStationSaga,
  setCityTimeSaga
} from './CitySagas'

import { bookTypes } from 'reduxModules/actions/BookActions'
import { addBookingSaga, getDepartureTimeSaga, addSavedBookingSaga } from './BookSagas'

import { priceTypes } from 'reduxModules/actions/PriceActions'
import { getPricesSaga, getCitiesRoutePriceSaga, setPriceSaga } from './PriceSagas'

import { dateTypes } from 'reduxModules/actions/DateActions'
import { selectDateSaga } from './DateSagas'

import { sourceTypes } from 'reduxModules/actions/SourceActions'
import {
  getSourcesSagas,
  addSourcesBookingSaga,
  resetSourceSaga,
  subscribeMonthSourcesDataSaga,
  updateMonthSourcesDataSagas,
  setMonthSourcesDataSagas
} from './SourceSagas'

import { authTypes } from 'reduxModules/actions/AuthActions'
import { emailSignInSaga, signOutSaga } from './AuthSagas'

import { playgroundTypes } from 'reduxModules/actions/PlaygroundActions'
import { getAllBookingsSaga } from './PlaygroundSagas'

import { phonetTypes } from 'reduxModules/actions/PhonetActions'
import { subscribeToCallSaga } from './PhonetSagas'

import { passengerTypes } from 'reduxModules/actions/PassengerActions'
import {
  getPassengerSaga,
  getPassengerBookingsSaga,
  setPassengerBookingSaga,
  setPassengerSaga,
  checkPassengerBookingsSaga
} from './PassengerSagas'

import { userTypes } from 'reduxModules/actions/UserActions'
import {
  getUserDataSaga,
  setUserHistorySaga,
  getUsersSaga,
  createUserSaga,
  resetUserPasswordSaga,
  getUserHistorySaga,
  deleteUserSaga,
  setUserLineIdSaga
} from './UserSagas'

import { routeTypes } from 'reduxModules/actions/RouteActions'
import {
  getRoutesSaga,
  subscribeInfoSaga,
  selectRouteSaga,
  changeRouteLimitSaga,
  setSourceDataSaga,
  setRouteInfoSaga,
  disableRouteSaga,
  subscribeWaitingPassengersSaga,
  setWaitingPassengersSaga,
  deleteWaitingPassengerSaga,
  addWaitingPassengerToSheetSaga
} from './RouteSagas'

import { blacklistTypes } from 'reduxModules/actions/BlacklistActions'
import {
  getBlacklistBookingsSaga,
  getBlacklistPassengerBookingsSaga,
  addBlacklistBookingSaga,
  deleteBlacklistBookingSaga,
  deleteBlacklistPassengerSaga,
  blacklistHandleRouteInfoSaga
} from './BlacklistSagas'

function* globalSaga() {
  yield all([
    takeLatest(globalTypes.SET_BUS_ATTEMPT, setBusSaga),
    takeLatest(globalTypes.GET_BUSES_ATTEMPT, getBusesSaga),
    takeLatest(globalTypes.DELETE_BUS_ATTEMPT, deleteBusSaga),
    takeLatest(globalTypes.CREATE_BUS_ATTEMPT, createBusSaga),
    takeLatest(globalTypes.SET_DRIVER_ATTEMPT, setDriverSaga),
    takeLatest(globalTypes.GET_DRIVERS_ATTEMPT, getDriversSaga),
    takeLatest(globalTypes.GET_CARRIERS_ATTEMPT, getCarriersSaga),
    takeLatest(globalTypes.DELETE_DRIVER_ATTEMPT, deleteDriverSaga),
    takeLatest(globalTypes.CREATE_DRIVER_ATTEMPT, createDriverSaga),
  ])
}

function* bookingSaga() {
  yield all([
    takeLatest(bookingTypes.SET_BOOKING_ATTEMPT, setBookingSaga),
    takeLatest(bookingTypes.DELETE_BOOKING_ATTEMPT, deleteBookingSaga),
    takeLatest(bookingTypes.SET_PASSENGER_PLACE_ATTEMPT, setPassengerPlaceSaga),
    takeLatest(bookingTypes.GET_USER_BOOKINGS_ATTEMPT, getUserBookingsSaga),
    takeLatest(bookingTypes.SET_BOOKING_STATUS_ATTEMPT, setBookingStatusSaga),
    takeLatest(bookingTypes.GET_RANGE_BOOKINGS_ATTEMPT, getRangeBookingsSaga),
    takeLatest(bookingTypes.SUBSCRIBE_BOOKINGS_ATTEMPT, subscribeBookingsSaga),
    takeLatest(bookingTypes.SUBSCRIBE_WEBSITE_BOOKINGS_ATTEMPT, subscribeWebsiteBookingsSaga),
    takeLatest(bookingTypes.GET_CARRIERS_BOOKINGS_ATTEMPT, getCarriersBookingsSaga),
    takeLatest(bookingTypes.SUBSCRIBE_RETURN_BOOKINGS_ATTEMPT, subscribeReturnBookingsSaga),
    takeLatest(bookingTypes.SUBSCRIBE_DEPARTURE_BOOKINGS_ATTEMPT, subscribeDepartureBookingsSaga),
  ])
}

function* bookSaga() {
  yield all([
    takeLatest(bookTypes.ADD_BOOKING_ATTEMPT, addBookingSaga),
    takeLatest(bookTypes.ADD_SAVED_BOOKING_ATTEMPT, addSavedBookingSaga),
    takeLatest(bookTypes.GET_DEPARTURE_TIME_ATTEMPT, getDepartureTimeSaga)
  ])
}

function* citySaga() {
  yield all([
    takeLatest(cityTypes.DISABLE_CITY_ATTEMPT, disableCitySaga),
    takeLatest(cityTypes.SET_CITY_TIME_ATTEMPT, setCityTimeSaga),
    takeLatest(cityTypes.GET_ALL_CITIES_ATTEMPT, getAllCitiesSaga),
    takeLatest(cityTypes.SET_SYSTEM_CITY_ATTEMPT, setSystemCitySaga),
    takeLatest(cityTypes.SET_CITY_STATION_ATTEMPT, setCityStationSaga),
    takeLatest(cityTypes.GET_ROUTE_CITIES_ATTEMPT, getRouteCitiesSaga),
  ])
}

function* priceSaga() {
  yield all([
    takeLatest(priceTypes.SET_PRICE_ATTEMPT, setPriceSaga),
    takeLatest(priceTypes.GET_PRICES_ATTEMPT, getPricesSaga),
    takeLatest(priceTypes.GET_CITIES_ROUTE_PRICE_ATTEMPT, getCitiesRoutePriceSaga)
  ])
}

function* sourceSaga() {
  yield all([
    takeLatest(sourceTypes.GET_SOURCES_ATTEMPT, getSourcesSagas),
    takeLatest(sourceTypes.RESET_SOURCE_ATTEMPT, resetSourceSaga),
    takeLatest(sourceTypes.ADD_SOURCE_BOOKING_ATTEMPT, addSourcesBookingSaga),
    takeLatest(sourceTypes.SET_MONTH_SOURCES_DATA_ATTEMPT, setMonthSourcesDataSagas),
    takeLatest(sourceTypes.UPDATE_MONTH_SOURCES_DATA_ATTEMPT, updateMonthSourcesDataSagas),
    takeLatest(sourceTypes.SUBSCRIBE_MONTH_SOURCES_DATA_ATTEMPT, subscribeMonthSourcesDataSaga),
  ])
}

function* dateSaga() {
  yield all([
    takeLatest(dateTypes.SELECT_DATE_ATTEMPT, selectDateSaga),
    // takeLatest(dateTypes.SELECT_RANGE_DATE_ATTEMPT, selectRangeDateSaga),
  ])
}

function* authSaga() {
  yield all([
    takeLatest(authTypes.SIGN_OUT_ATTEMPT, signOutSaga),
    takeLatest(authTypes.EMAIL_SIGN_IN_ATTEMPT, emailSignInSaga),
  ])
}

function* userSaga() {
  yield all([
    takeLatest(userTypes.GET_USERS_ATTEMPT, getUsersSaga),
    takeLatest(userTypes.CREATE_USER_ATTEMPT, createUserSaga),
    takeLatest(userTypes.DELETE_USER_ATTEMPT, deleteUserSaga),
    takeLatest(userTypes.GET_USER_DATA_ATTEMPT, getUserDataSaga),
    takeLatest(userTypes.SET_USER_LINE_ID_ATTEMPT, setUserLineIdSaga),
    takeLatest(userTypes.GET_USER_HISTORY_ATTEMPT, getUserHistorySaga),
    takeLatest(userTypes.SET_USER_HISTORY_ATTEMPT, setUserHistorySaga),
    takeLatest(userTypes.RESET_USER_PASSWORD_ATTEMPT, resetUserPasswordSaga),
  ])
}

function* routeSaga() {
  yield all([
    takeLatest(routeTypes.GET_ROUTES_ATTEMPT, getRoutesSaga),
    takeLatest(routeTypes.SELECT_ROUTE_ATTEMPT, selectRouteSaga),
    takeLatest(routeTypes.DISABLE_ROUTE_ATTEMPT, disableRouteSaga),
    takeLatest(routeTypes.SET_ROUTE_INFO_ATTEMPT, setRouteInfoSaga),
    takeLatest(routeTypes.SUBSCRIBE_INFO_ATTEMPT, subscribeInfoSaga),
    takeLatest(routeTypes.SET_SOURCE_DATA_ATTEMPT, setSourceDataSaga),
    takeLatest(routeTypes.CHANGE_ROUTE_LIMIT_ATTEMPT, changeRouteLimitSaga),
    takeLatest(routeTypes.SET_WAITING_PASSENGER_ATTEMPT, setWaitingPassengersSaga),
    takeLatest(routeTypes.DELETE_WAITING_PASSENGER_ATTEMPT, deleteWaitingPassengerSaga),
    takeLatest(routeTypes.SUBSCRIBE_WAITING_PASSENGERS_ATTEMPT, subscribeWaitingPassengersSaga),
    takeLatest(routeTypes.ADD_WAITING_PASSENGER_TO_SHEET_ATTEMPT, addWaitingPassengerToSheetSaga),
  ])
}

function* playgroundSaga() {
  yield all([
    takeEvery(playgroundTypes.GET_ALL_BOOKINGS_ATTEMPT, getAllBookingsSaga),
  ])
}

function* passengerSaga() {
  yield all([
    takeLatest(passengerTypes.GET_PASSENGER_ATTEMPT, getPassengerSaga),
    takeLatest(passengerTypes.SET_PASSENGER_ATTEMPT, setPassengerSaga),
    takeLatest(passengerTypes.SET_PASSENGER_BOOKING_ATTEMPT, setPassengerBookingSaga),
    takeLatest(passengerTypes.GET_PASSENGER_BOOKINGS_ATTEMPT, getPassengerBookingsSaga),
    takeLatest(passengerTypes.CHECK_PASSENGER_BOOKINGS_ATTEMPT, checkPassengerBookingsSaga),
  ])
}

function* phonetSaga() {
  yield all([
    takeLatest(phonetTypes.SUBSCRIBE_TO_CALL_ATTEMPT, subscribeToCallSaga),
  ])
}

function* blacklistSaga() {
  yield all([
    takeLatest(blacklistTypes.GET_BLACKLIST_BOOKINGS_ATTEMPT, getBlacklistBookingsSaga),
    takeLatest(blacklistTypes.GET_BLACKLIST_PASSENGER_BOOKINGS_ATTEMPT, getBlacklistPassengerBookingsSaga),
    takeLatest(blacklistTypes.ADD_BLACKLIST_BOOKING_ATTEMPT, addBlacklistBookingSaga),
    takeLatest(blacklistTypes.DELETE_BLACKLIST_BOOKING_ATTEMPT, deleteBlacklistBookingSaga),
    takeLatest(blacklistTypes.DELETE_BLACKLIST_PASSENGER_ATTEMPT, deleteBlacklistPassengerSaga),
    takeLatest(blacklistTypes.BLACKLIST_HANDLE_ROUTE_INFO_ATTEMPT, blacklistHandleRouteInfoSaga),
  ])
}

export function* rootSaga() {
  yield all([
    playgroundSaga(),
    passengerSaga(),
    blacklistSaga(),
    bookingSaga(),
    phonetSaga(),
    globalSaga(),
    sourceSaga(),
    priceSaga(),
    routeSaga(),
    bookSaga(),
    citySaga(),
    authSaga(),
    userSaga(),
    dateSaga(),
  ])
}



// WEBPACK FOOTER //
// ./src/reduxModules/sagas/index.js